export { App as default } from '@guiker/propsharing-main-mfe'
